<span class="error-title">
  {{params.title}}
</span>
<p [innerHtml]="params.text">
</p>
<a *ngIf="isButtonVisible() && !isButtonLinkRouteType()" [attr.href]="getButtonHref()" class="general-button send-me-code" >{{getButtonText()}}</a>
<a *ngIf="isButtonVisible() && isButtonLinkRouteType()" (click)="navigateUrl()" class="general-button send-me-code">{{getButtonText()}}</a>
<a *ngIf="params.button.isButtonForTryAgain" (click)="buttonForTryAgainClick()" class="general-button send-me-code">{{params.button.buttonForTryAgainText}}</a>